export default "__VITE_ASSET__2GDfcEqS__"